import * as React from 'react';
import { Calendar as CalendarIcon } from '@phosphor-icons/react';

import { cn } from '../../../lib/utils';
import { EtaDisplay } from './EtaDisplay';

const SET_TRIGGER =
  'border border-transparent outline-none hover:border-border hover:bg-muted hover:shadow-xs focus-visible:border-border focus-visible:bg-muted focus-visible:shadow-xs focus-visible:ring-2 focus-visible:ring-ring -mx-1.5 rounded-md px-1.5 py-1 text-left transition-all disabled:cursor-not-allowed disabled:opacity-50';
const UNSET_TRIGGER =
  'border-border text-body-sm-medium text-muted-foreground outline-none hover:border-primary hover:text-primary focus-visible:border-primary focus-visible:text-primary focus-visible:ring-2 focus-visible:ring-ring inline-flex items-center gap-1.5 rounded-full border border-dashed px-3 py-1.5 transition-colors disabled:cursor-not-allowed disabled:opacity-50';

export interface EtaTriggerProps extends Omit<React.ComponentPropsWithoutRef<'button'>, 'value'> {
  /** Current ETA (ISO-8601) or null/undefined when unset. */
  value?: string | null;
}

/**
 * Popover trigger for the ETA picker: set → the relative/exact block, unset → a
 * dashed "Set ETA" pill. forwardRef so Radix `PopoverTrigger asChild` can wire it.
 */
export const EtaTrigger = React.forwardRef<HTMLButtonElement, EtaTriggerProps>(
  ({ value, className, ...props }, ref) => {
    if (value) {
      return (
        <button
          ref={ref}
          type="button"
          aria-label="Edit ETA"
          title="Tap to edit"
          className={cn(SET_TRIGGER, className)}
          {...props}
        >
          <EtaDisplay iso={value} />
        </button>
      );
    }
    return (
      <button
        ref={ref}
        type="button"
        aria-label="Set ETA"
        className={cn(UNSET_TRIGGER, className)}
        {...props}
      >
        <CalendarIcon size={14} weight="regular" aria-hidden />
        Set ETA
      </button>
    );
  },
);
EtaTrigger.displayName = 'EtaTrigger';
